/**
 * Structural rules for VAT identifier
 * @source http://ec.europa.eu/taxation_customs/vies/faqvies.do#item_11
 */
const VatIdentifierValidatorVar = {
    // AT-Austria
    // format:  1 block of 9 characters
    // example: ATU99999999
    AT: {
        country: 'AT',
        regex: /^[U]{1}\d{8}$/,
        length: 9,
    },
    // BE-Belgium
    // format:  1 block of 10 digits
    // example: BE0999999999 or BE1999999999
    BE: {
        country: 'BE',
        regex: /^[0,1]{1}\d{9}$/,
        length: 10,
    },
    // BG-Bulgaria
    // format:  1 block of 9 digits or 1 block of 10 digits
    // example: BG999999999 or BG9999999999
    BG: {
        country: 'BG',
        regex: /^\d{9,10}$/,
        length: [9, 10],
    },
    // CH-Suisse
    // format:  1 block of 10 characters optionally followed by "MWST", "TVA" or "IVA"
    // example: CHE999999999
    CH: {
        country: 'CH',
        regex: /^[E]{1}\d{9}(MWST|TVA|IVA)?$/,
        length: [10, 13, 14],
    },
    // CY-Cyprus
    // format:  1 block of 9 characters (last character is a letter)
    // example: CY99999999L
    CY: {
        country: 'CY',
        regex: /^[\d]{8}[A-Z]{1}$/,
        length: 9,
    },
    // CZ-Czech Republic
    // format:  1 block of either 8, 9 or 10 digits
    // example: CZ99999999 or CZ999999999 or CZ9999999999
    CZ: {
        country: 'CZ',
        regex: /^\d{8,10}$/,
        length: [8, 9, 10],
    },
    // DE-Germany
    // format:  1 block of 9 digits
    // example: DE999999999
    DE: {
        country: 'DE',
        regex: /^\d{9}$/,
        length: 9,
    },
    // DK-Denmark
    // format:  4 blocks of 2 digits
    // example: DK99 99 99 99
    DK: {
        country: 'DK',
        regex: /^\d{8}$/,
        length: 8,
    },
    // EE-Estonia
    // format:  1 block of 9 digits
    // example: EE999999999
    EE: {
        country: 'EE',
        regex: /^\d{9}$/,
        length: 9,
    },
    // ES-Spain
    // format:  1 block of 9 characters (Note: The first and last characters may be alpha or numeric. But they may not both be numeric.)
    // example: ESX9999999X, ESX99999999, ES99999999X
    ES: {
        country: 'ES',
        regex: /(^[A-Z\d]{1}\d{7}[A-Z]{1}$|^[A-Z]{1}[\d]{7}[A-Z\d]{1}$)/,
        length: 9,
    },
    // FI-Finland
    // format:  1 block of 8 digits
    // example: FI99999999
    FI: {
        country: 'FI',
        regex: /^\d{8}$/,
        length: 8,
    },
    // FR-France
    // format:  1 block of 2 characters, 1 block of 9 digits
    // example: FRX9 999999999, FRXX 999999999, FR99 999999999
    FR: {
        country: 'FR',
        regex: /^[A-Z\d]{2}[\d]{9}$/,
        length: 11,
    },
    // GB-United Kingdom
    // format:  1 block of 3 digits, 1 block of 4 digits and 1 block of 2 digits; or the above followed by a block of 3 digits; or 1 block of 5 characters
    // example: GB999 9999 99 or GB999 9999 99 999 or GBGD999 or GBHA999
    GB: {
        country: 'GB',
        regex: /(^[\d]{9}([\d]{3})?$)|(^(GD|HA)[\d]{3}$)/,
        length: [5, 9, 12],
    },
    // GR-Greece
    // format:  1 block of 9 digits
    // example: EL999999999
    GR: {
        country: 'EL',
        regex: /^\d{9}$/,
        length: 9,
    },
    // HR-Croatia
    // format:  1 block of 11 digits
    // example: HR99999999999
    HR: {
        country: 'HR',
        regex: /^\d{11}$/,
        length: 11,
    },
    // HU-Hungary
    // format:  1 block of 8 digits
    // example: HU99999999
    HU: {
        country: 'HU',
        regex: /^\d{8}$/,
        length: 8,
    },
    // IE-Ireland
    // format:  1 block of 8 characters or 1 block of 9 characters
    // example: IE9S99999L IE9999999WI
    IE: {
        country: 'IE',
        regex: /(^\d{1}[A-Z\d+*]{1}[\d]{5}[A-Z]{1}$)|(^\d{7}(WI){1}$)/,
        length: [8,9],
    },
    // IT-Italy
    // format:  1 block of 11 digits
    // example: IT99999999999
    IT: {
        country: 'IT',
        regex: /^\d{11}$/,
        length: 11,
    },
    // LT-Lithuania
    // format:  1 block of 9 digits, or 1 block of 12 digits
    // example: LT999999999 or LT999999999999
    LT: {
        country: 'LT',
        regex: /^\d{9}(\d{3})?$/,
        length: [9, 12],
    },
    // LU-Luxembourg
    // format:  1 block of 8 digits
    // example: LU99999999
    LU: {
        country: 'LU',
        regex: /^\d{8}$/,
        length: 8,
    },
    // LV-Latvia
    // format:  1 block of 11 digits
    // example: LV99999999999
    LV: {
        country: 'LV',
        regex: /^\d{11}$/,
        length: 11,
    },
    // MT-Malta
    // format:  1 block of 8 digits
    // example: MT99999999
    MT: {
        country: 'MT',
        regex: /^\d{8}$/,
        length: 8,
    },
    // NL-The Netherlands
    // format:  1 block of 12 characters (letter,digit,"+","*")
    // example: NLSSSSSSSSSSSS, NL4+SS*99S9999
    NL: {
        country: 'NL',
        regex: /^[A-Z\d+*]{12}$/,
        length: 12,
    },
    // PL-Poland
    // format:  1 block of 10 digits
    // example: PL9999999999
    PL: {
        country: 'PL',
        regex: /^\d{10}$/,
        length: 10,
    },
    // PT-Portugal
    // format:  1 block of 9 digits
    // example: PT999999999
    PT: {
        country: 'PT',
        regex: /^\d{9}$/,
        length: 9,
    },
    // RO-Romania
    // format:  1 block of minimum 2 digits and maximum 10 digits
    // example: RO999999999
    RO: {
        country: 'RO',
        regex: /^\d{2,10}$/,
        length: [2, 3, 4, 5, 6, 7, 8, 9, 10],
    },
    // RU-Russia
    // format:  1 block of 10 digits or 1 block of 12 digits
    // example: RU9999999999
    RU: {
        country: 'RU',
        regex: /^(\d{10}|\d{12})$/,
        length: [10, 12],
    },
    // RS-Serbia
    // format:  1 block of 9 digits
    // example: RS999999999
    RS: {
        country: 'RS',
        regex: /^\d{9}$/,
        length: 9,
    },
    // SE-Sweden
    // format:  1 block of 12 digits
    // example: SE999999999999
    SE: {
        country: 'SE',
        regex: /^\d{12}$/,
        length: 12,
    },
    // SI-Slovenia
    // format:  1 block of 8 digits
    // example: SI99999999
    SI: {
        country: 'SI',
        regex: /^\d{8}$/,
        length: 8,
    },
    // SK-Slovakia
    // format:  1 block of 10 digits
    // example: SK9999999999
    SK: {
        country: 'SK',
        regex: /^\d{10}$/,
        length: 10,
    },
}

const FrenchCountries = ['FR','MC','MQ','GP','RE']

class VatIdentifierValidator {
    constructor(country)
    {
        if (-1 !== FrenchCountries.indexOf(country.toUpperCase())) {
            country = "FR";
        }

        let validator = VatIdentifierValidatorVar[country];
        // country not found to validate
        if (validator === undefined) return;

        if (!_.isString(validator.country)) throw new Error(`The property string "country" must be defined on validator '${country}'`);
        if (!_.isObject(validator.regex)) throw new Error(`The property string "regex" must be defined on validator '${country}'`);
        if (!_.isNumber(validator.length) && !_.isArray(validator.length)) throw new Error(`The property string|array "length" must be defined on validator '${country}'`);

        this.validator = validator;
    }
    isValid(identifier)
    { 
        identifier = identifier.toUpperCase();
        return this.hasRequiredLength(this.trimCountryAndSpaces(identifier)) 
            && this.isFormatValid(identifier); 
    }
    hasRequiredLength(identifier) 
    {
        if (_.isNumber(this.validator.length)) {
            return this.trimCountryAndSpaces(identifier).length === this.validator.length;
        } else {
            return this.validator.length.indexOf(this.trimCountryAndSpaces(identifier).length) !== -1;
        }
    }
    isFormatValid(identifier) 
    { 
        return this.hasCountryInIdentifier(identifier)
            && this.validator.regex.test(this.trimCountryAndSpaces(identifier));
    }
    hasCountryInIdentifier(identifier)
    {
        let regex = new RegExp(`${this.validator.country}`, 'g');
        return regex.test(identifier);
    }
    trimCountryAndSpaces(identifier) 
    { 
        let regex = new RegExp(`^${this.validator.country}|\\s+`, "g");
        return identifier.replace(regex, '');
    }
}

export default VatIdentifierValidator